import React from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";



const VendorRatingMenu = () => {
   useAuthRedirect();

   const canView  = hasPermission("Vendor Rating", "view");

   if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vendor Rating Report
          </h2>
          <Time />
        </section>

     <div className="container">
      <table className="transaction-table ">
        <thead>
          <tr>
            <th className="table-header">Vendor Rating Reports</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><Link to="/inventory/rptVCRqualityGrn">Quality Rating - GRN</Link></td>
          </tr>
          <tr>
            <td><Link to="/inventory/rptVCRDeliveryGrn">Delivery Rating - GRN</Link></td>
          </tr>
          <tr>
          <td><Link to="/inventory/rptSupplierRatingGrn">Supplier Rating - GRN</Link></td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    </div>
  );
};

export default VendorRatingMenu;
